/* ═══════════════════════════════════════════════════════════
   VIDEO POPUP — session-gated commercial over the homepage
   ═══════════════════════════════════════════════════════════ */

.backdrop {
  position: fixed;
  inset: 0;
  z-index: 9500;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: clamp(0.75rem, 3vw, 2.5rem);
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  animation: videoPopupFade 200ms ease-out both;
}

.card {
  position: relative;
  width: min(100%, 1100px);
  animation: videoPopupScale 200ms ease-out both;
}

.close {
  position: absolute;
  top: -12px;
  right: -12px;
  z-index: 10;
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: rgba(10, 10, 10, 0.92);
  color: var(--color-text-primary);
  cursor: pointer;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);
  transition: background 150ms ease-out, transform 150ms ease-out;
}

.close:hover {
  background: rgba(30, 30, 30, 0.96);
  transform: scale(1.06);
}

.close:focus-visible {
  outline: 2px solid var(--color-text-primary);
  outline-offset: 2px;
}

@media (max-width: 640px) {
  .close {
    top: 8px;
    right: 8px;
  }
}

@keyframes videoPopupFade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes videoPopupScale {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@media (prefers-reduced-motion: reduce) {
  .backdrop,
  .card {
    animation: none;
  }
  .close {
    transition: none;
  }
}
